var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoNoProductFound = function SvgIcoNoProductFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 209 208"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    x: 0.5,
    rx: 104
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ico_no_product_found_svg__a",
    width: 97,
    height: 96,
    x: 56,
    y: 56,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 56h96v96h-96z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ico_no_product_found_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M64.5 138v-32h32v32zm8-8h16v-16h-16zm6-34 22-36 22 36zm14.2-8h15.6l-7.8-12.6zm50.1 59.8-10.6-10.6a16.2 16.2 0 0 1-4.55 2.1q-2.45.7-5.15.7-7.5 0-12.75-5.25T104.5 122t5.25-12.75T122.5 104t12.75 5.25T140.5 122a18.3 18.3 0 0 1-.7 5.05 18 18 0 0 1-2 4.55l10.6 10.6zM122.5 132q4.2 0 7.1-2.9t2.9-7.1-2.9-7.1-7.1-2.9-7.1 2.9-2.9 7.1 2.9 7.1 7.1 2.9"
  }))));
};
export default SvgIcoNoProductFound;